import { FormInput } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "components.messages.";

export const GroupingIdentifierField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  if (
    !automation ||
    !automation.code ||
    !["1", "5", "11", "16", "17", "18", "22", "23", "24", "34"].includes(
      automation.code,
    )
  )
    return null;

  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="groupingIdentifier"
        fullWidth
        label={
          t(translationPath + "groupingIdentifier") || "groupingIdentifier"
        }
      />
      <FormHelperText>
        {t(translationPath + "groupingIdentifierMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
